import { useMutation } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'

type UseBookingsExportMutationProps = {
	onSuccess: (res: any) => void
	onSettled: () => void
}

export const useBookingsExportMutation = ({
	onSuccess,
	onSettled
}: UseBookingsExportMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: exportBookingsMutation, isPending: isExportBookingsLoading } = useMutation({
		mutationFn: ({ ids, format }: { ids: number[]; format: string | number | null }) => {
			return axiosPrivate.post(
				apiRoutes.bookingsExport,
				{ format, ids },
				{ responseType: 'arraybuffer' }
			)
		},
		onSuccess: (res) => {
			onSuccess(res)
			useToast({
				type: 'success',
				message: t('Export succeeded')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		exportBookingsMutation,
		isExportBookingsLoading
	}
}
